type TPlusIconProps = {
  className?: string;
};

export const PlusIcon = ({ className }: TPlusIconProps) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_1831_109850)">
      <path
        d="M10.0003 18.3333C14.6027 18.3333 18.3337 14.6024 18.3337 9.99999C18.3337 5.39762 14.6027 1.66666 10.0003 1.66666C5.39795 1.66666 1.66699 5.39762 1.66699 9.99999C1.66699 14.6024 5.39795 18.3333 10.0003 18.3333Z"
        stroke=""
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 6.66667V13.3333" stroke="" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.66602 10H13.3327" stroke="" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1831_109850">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
